<script setup lang="ts">
import type { Component } from "../types.ts";
import ElementRenderer from "./ElementRenderer.vue";

defineProps<{
  elements: Component[],
  item: Component
}>();
</script>

<template>
    <ElementRenderer :elements="elements" />
</template>